import utils from '@/mixins/utils.js'
import { getQuantidadeProcedimentosPreventivos } from './functions.js'

/**
 * Monta os campos exportados para XLS.
 *
 * @param {Object|String|Number|null} mes Mês selecionado no filtro.
 * @param {Boolean} exibirSemPrevencao Indica se o filtro de sem prevenção está ativo.
 * @returns {Object}
 */
export function getDataFields(mes = null, exibirSemPrevencao = false) {
  const colunaQuantidade = exibirSemPrevencao ? 'Outros' : 'Preventivos'

  return {
    Nome: 'no_cidadao',
    'Data de nascimento': {
      callback: (item) => {
        return `${utils.methods.formatDate(item.dt_nascimento)} (${
          item.idade
        } ${item.idade > 1 ? 'anos' : 'ano'})`
      },
    },
    Mãe: 'no_mae',
    [colunaQuantidade]: {
      callback: (item) => {
        return getQuantidadeProcedimentosPreventivos(
          item,
          mes,
          exibirSemPrevencao
        )
      },
    },
  }
}

export const infoHtml = ``
